/**
 * Bubble helper functions
 * Utility functions for working with bubbles
 */

/**
 * Get the last unlocked bubble number (1-based)
 */
export function getLastUnlockedBubble(unlockedBubbleIds: Set<string>): number | null {
  if (unlockedBubbleIds.size === 0) return null
  // Return the last bubble number (1-based) from the set
  const sortedIds = Array.from(unlockedBubbleIds).sort()
  const lastBubbleId = sortedIds[sortedIds.length - 1]
  if (!lastBubbleId) return null

  // Extract number from bubble ID (e.g., "bubble-3" -> 3)
  const match = lastBubbleId.match(/bubble-(\d+)/)
  if (match) {
    return parseInt(match[1], 10)
  }
  // Fallback: try to extract number from end of string
  const numMatch = lastBubbleId.match(/(\d+)$/)
  return numMatch ? parseInt(numMatch[1], 10) : null
}

/**
 * Get the last clicked action point number (1-based)
 */
export function getLastClickedActionPoint(clickedActionPointIndices: Set<number>): number | null {
  if (clickedActionPointIndices.size === 0) return null
  // Return the last action point number (1-based, was 0-based index)
  const maxIndex = Math.max(...Array.from(clickedActionPointIndices))
  return maxIndex + 1 // Convert from 0-based index to 1-based number
}
